import { Box } from '@chakra-ui/react';

import { KybDocument } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import ErrorView from 'components/ErrorView';
import OBFileItem from 'features/Onboarding/components/OBFileItem';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import { locales } from './locales';

interface ProofOfFundsIntroProps {
  onContinue: () => void;

  review?: {
    document: Pick<KybDocument, 'kybDocumentId' | 'status' | 'type' | 'url'>;
    onDelete: (documentId: string) => void;
    isDeleting: boolean;
  };
}

const ProofOfFundsReview = asBentoPage<ProofOfFundsIntroProps>(
  ({ Layout, onContinue, onPrev, review }) => {
    if (!review) {
      return <ErrorView />;
    }

    return (
      <Layout
        data-testid="company-papers-hub"
        nav={<OBNavigation onPrev={review.isDeleting ? undefined : onPrev} />}
      >
        <Box marginBottom="space-40">
          <Heading marginBottom="space-32" size="lg">
            {locales.title}
          </Heading>
          <OBFileItem
            fileName={locales.documentName}
            isLoading={review.isDeleting}
            onDeleteClick={() => review.onDelete(review.document.kybDocumentId)}
            onPreviewClick={() =>
              review.document.url && window.open(review.document.url, '_blank')
            }
          />
        </Box>
        <Button isDisabled={review.isDeleting} isExpanded onClick={onContinue}>
          {locales.ctaContinue}
        </Button>
      </Layout>
    );
  },
);

export default ProofOfFundsReview;
